// extracted by mini-css-extract-plugin
module.exports = {"Component":"CopyAgreement_Component__3S83U","Icon":"CopyAgreement_Icon__3HA7N","Message":"CopyAgreement_Message__3ltrs","BtnCancel":"CopyAgreement_BtnCancel__2J-6g"};